import { Grid } from "@material-ui/core";
import { useGetIndicacaoRevendedores } from "data/api/gestao/indicacao-revendedores/get-indicacao-revendedores";
import { useCallback, useEffect, useState } from "react";
import { useCadastros, useToastSaurus } from "services/app";
import { CircularLoading } from "views/components";
import { Paginacao } from "views/components/paginacao";
import { useDefaultCadastroStyles } from "views/pages/private/cadastros/components/default-cadastro-styles";
import { IndicacaoRevendedoresListData } from "./indicacao-revendedores-list-data";
import { useLocation } from "react-router-dom";
import { IndicacaoRevendedoresListSearchProps } from "./indicacao-revendedores-list-search-props";

export interface IndicacaoRevendedoresListProps {
    searchProps: IndicacaoRevendedoresListSearchProps
}

export const IndicacaoRevendedoresList: React.FC<IndicacaoRevendedoresListProps> = (props) => {
    const cadastroClasses = useDefaultCadastroStyles();
    const { showToast } = useToastSaurus()
    const { getIndicacaoRevendedores, carregando } = useGetIndicacaoRevendedores()
    const { abrirCadastroIndicacaoRevendedor } = useCadastros()
    const [selectedList, setSelectedList] = useState<Array<string>>([]);
    const location = useLocation()

    const [queryStatus, setQueryStatus] = useState({
        page: 1,
        totalPages: 0,
        totalResults: 0,
        list: Array<any>(),
    });

    const fillResult = useCallback(
        async (
            page: number,
            totalPages: number,
            totalResults: number,
            list: Array<any>
        ) => {
            setQueryStatus({
                page: page,
                list: list,
                totalResults: totalResults,
                totalPages: totalPages,
            });
        },
        []
    );

    const search = useCallback(
        async (newPage: number) => {
            try {
                const res = await getIndicacaoRevendedores(
                    newPage,
                    `pageSize=18&query=${props.searchProps.termo}`
                );
                if (res.erro) throw res.erro;

                if (!res.resultado) return
                //se o index for maior que as paginas ele busca a ultima
                if (
                    res.resultado?.data?.pageIndex > res.resultado?.data?.totalPages &&
                    res.resultado?.data?.totalResults > 0
                ) {
                    search(res.resultado?.data?.totalPages);
                    return;
                }

                fillResult(
                    res.resultado?.data?.pageIndex,
                    res.resultado?.data?.totalPages,
                    res.resultado?.data?.totalResults,
                    res.resultado?.data?.list
                );

                return res;
            } catch (e: any) {
                showToast("error", e.message);
            }
        },
        [getIndicacaoRevendedores, props.searchProps.termo, fillResult, showToast]
    );

    const onCardSelected = (id: string) => {
        abrirCadastroIndicacaoRevendedor(id, location.pathname, true)
        setSelectedList((prev) => {
            const newList = [...prev];
            const index = newList.indexOf(id);
            if (index > -1) {
                newList.splice(index, 1);
            } else {
                newList.push(id);
            }
            return newList;
        });
    };

    const onCardChecked = (id: string) => {
    };

    const pageChanged = useCallback(
        async (newPage: number) => {
            if (newPage <= queryStatus.totalPages || newPage > 0) {
                search(newPage);
            }
        },
        [search, queryStatus.totalPages]
    );

    useEffect(() => {
        search(queryStatus.page);
    }, [queryStatus.page, search])

    return (
        <div className={cadastroClasses.defaultContainer}>
            {carregando && <CircularLoading tipo="FULLSIZED" />}
            <Grid container className={cadastroClasses.listContainer}>
                <Paginacao
                    pageChanged={pageChanged}
                    totalPages={queryStatus.totalPages}
                    totalRegisters={queryStatus.totalResults}
                    currentPage={queryStatus.page}
                />
            </Grid>
            <Grid item xs={12} className={cadastroClasses.listContainer}>
                <Grid>
                    <IndicacaoRevendedoresListData
                        carregando={carregando}
                        list={queryStatus.list}
                        selectedList={selectedList}
                        onCardSelected={onCardSelected}
                        onCardChecked={onCardChecked}
                    />
                </Grid>
            </Grid>
        </div>
    )
}